export function joinFilterSelections(selections, acqSelections) {

  // Add Tag
  for(let sectionIdx in selections) {
    selections[sectionIdx].label += " (Customer)"
  }
  for(let sectionIdx in acqSelections) {
    acqSelections[sectionIdx].label += " (Prospect)"
  }
  return selections.concat(acqSelections)
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataAgg/joinFilterSelection.js